import React from 'react';
import { Link } from 'react-router-dom';

const quickLinks = [
  { to: '/aims-and-scope', label: 'Aims & Scope' },
  { to: '/editorial-board', label: 'Editorial Board' },
  { to: '/author-guidelines', label: 'Author Guidelines' },
  { to: '/peer-review-policy', label: 'Peer Review Policy' },
  { to: '/articles', label: 'Articles' },
  { to: '/issues', label: 'Issues' },
  { to: '/submit', label: 'Submit Manuscript' },
  { to: '/contact', label: 'Contact' },
  { to: '/about', label: 'About' },
];

function Footer() {
  return (
    <footer className="bg-navy text-white border-t-2 border-amber mt-auto">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10">
          {/* Left: Journal identity */}
          <div className="flex flex-col gap-3">
            <div className="flex items-center gap-2">
              <div className="w-1 h-8 bg-amber rounded-full" aria-hidden="true" />
              <div>
                <span className="font-display font-bold text-amber text-lg block leading-tight">
                  JAMSD
                </span>
              </div>
            </div>
            <p className="font-display text-slate-pale text-sm leading-relaxed">
              Journal of Applied Medical and Surgical Disciplines
            </p>
            <p className="font-sans text-slate-light text-xs">
              ISSN: XXXX-XXXX (pending assignment)
            </p>
            {/* <p className="font-sans text-slate-light text-xs">
              &copy; 2025 Infokai Technologies Pvt. Ltd.
            </p> */}
            <p className="font-sans text-slate-light text-xs">
              All rights reserved.
            </p>
            <div className="flex items-center gap-2 mt-1">
              <span className="inline-block bg-amber-tint text-amber-tinttext text-xs font-sans font-semibold px-2 py-0.5 rounded">
                Open Access
              </span>
              <span className="inline-block bg-navy-medium text-slate-pale text-xs font-sans px-2 py-0.5 rounded border border-navy-border">
                CC BY 4.0
              </span>
            </div>
          </div>

          {/* Center: Quick links */}
          <div>
            <h3 className="font-display text-white font-semibold text-base mb-4 border-b border-navy-border pb-2">
              Quick Links
            </h3>
            <ul className="grid grid-cols-1 gap-2">
              {quickLinks.map((link) => (
                <li key={link.to}>
                  <Link
                    to={link.to}
                    className="font-sans text-sm text-slate-light hover:text-amber transition-colors flex items-center gap-1.5"
                  >
                    <svg className="w-3 h-3 text-amber flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                    </svg>
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Right: Publisher info */}
          <div>
            {/* <h3 className="font-display text-white font-semibold text-base mb-4 border-b border-navy-border pb-2">
              Publisher
            </h3>
            <p className="font-sans text-slate-light text-sm mb-1">Published by</p>
            <p className="font-sans text-white font-semibold text-sm mb-4">
              Infokai Technologies Pvt. Ltd.
            </p> */}

            <h4 className="font-display text-white font-semibold text-sm mb-2">Editorial Contact</h4>
            <a
              href="mailto:editor@jamsd.org"
              className="font-sans text-amber text-sm hover:text-amber-dark transition-colors"
            >
              editor@jamsd.org
            </a>

            <div className="mt-6">
              <h4 className="font-display text-white font-semibold text-sm mb-2">Publication Schedule</h4>
              <p className="font-sans text-slate-light text-xs leading-relaxed">
                Biannual — Spring and Fall issues each year.
                <br />
                First Published: 2026
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom strip */}
      <div className="border-t border-navy-border bg-navy-medium">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-3">
          <p className="font-sans text-xs text-slate-light text-center leading-relaxed">
            The Journal of Applied Medical and Surgical Disciplines is an open-access journal. All content published
            is available under{' '}
            <a
              href="https://creativecommons.org/licenses/by/4.0/"
              target="_blank"
              rel="noopener noreferrer"
              className="text-amber hover:text-amber-dark transition-colors underline"
            >
              CC BY 4.0 license
            </a>
            .
          </p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
